import { Tooltip, TooltipTrigger } from '@trellis/roots/tooltip'

import { reminderMarkDotKind, ReminderMarkDot } from './ReminderMarkDot'
import {
  describeReminderOffsetSentence,
  ReminderMarkTooltipContent,
} from './ReminderMarkTooltipContent'
import { REMINDER_MARK_DOT_LABELS } from './reminders.constants'

/**
 * The same dot a schedule shows on its timeline, for one scheduled reminder: sky mail,
 * amber bell, both, or hollow for a repeat. Keeps colour and icon meaning consistent.
 */
export function ReminderChannelBadge({
  reminder,
}: {
  reminder: {
    emailClient: boolean
    alertStaff: boolean
    isRepeat?: boolean
    daysRelativeToDue: number
  }
}) {
  const kind = reminderMarkDotKind({ ...reminder, isRepeat: reminder.isRepeat ?? false })
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span
          role="img"
          aria-label={REMINDER_MARK_DOT_LABELS[kind]}
          tabIndex={0}
          className="focus-visible:ring-ring inline-flex rounded-full focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:outline-none"
        >
          <ReminderMarkDot kind={kind} size="sm" />
        </span>
      </TooltipTrigger>
      <ReminderMarkTooltipContent
        kind={kind}
        detail={describeReminderOffsetSentence(reminder.daysRelativeToDue)}
      />
    </Tooltip>
  )
}
